import { ChangeEvent, useRef, useState } from 'react'

import { useRequest } from 'ahooks'
import { Input, Space } from 'antd'
import { isNil } from 'lodash'

import { queryBankCardApi } from '@eastcoal/api/nexus/bank/queryBankCard'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { formatBankCard } from '@eastcoal/common/utils/bankCard'

import { MemberType } from '../../enums/MemberType'

import { BankCardInputProps } from './interface'

export const BankCardInput = ({
  type,
  disabled,
  allowClear = true,
  value,
  onChange,
  placeholder
}: BankCardInputProps) => {
  const rawValueRef = useRef<string>('')
  const [formatValue, setFormatValue] = useState<string>()

  // 不在 effect 中同步本地 state；展示值优先使用本地输入格式化值，否则回退到 props 提供的格式化值

  const { loading, runAsync } = useRequest(queryBankCardApi, {
    manual: true,
    onSuccess: data => {
      onChange?.({
        ...data,
        bankAccount: rawValueRef.current
      })
    },
    onError() {
      onChange?.({})
    }
  })

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const bankAccount = event.target.value.replace(/\s/g, '')
    const cardNo = formatBankCard(bankAccount)
    rawValueRef.current = bankAccount
    onChange?.({ bankAccount, bankName: value?.bankName })
    setFormatValue(cardNo)
  }

  const handleSearch = () => {
    const current = rawValueRef.current || value?.bankAccount
    if (current) {
      // 个人银行卡进行识别
      runAsync({ cardno: current })
    } else {
      onChange?.({})
    }
  }

  const handleBlur = () => {
    const bankAccount = rawValueRef.current || value?.bankAccount
    onChange?.({ bankAccount, bankName: value?.bankName })
  }

  const inputValue =
    formatValue ??
    (isNil(value?.bankAccount) ? undefined : formatBankCard(value.bankAccount))

  return type === MemberType.PERSON ? (
    <Space.Compact
      style={{
        width: '100%'
      }}
    >
      <Input
        allowClear={allowClear}
        disabled={disabled}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        onPressEnter={handleSearch}
      />
      <ThrottleButton loading={loading} type='default' onClick={handleSearch}>
        识别
      </ThrottleButton>
    </Space.Compact>
  ) : (
    <Input
      allowClear={allowClear}
      disabled={disabled}
      placeholder={placeholder}
      value={inputValue}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  )
}
